<div class="backpage-wrapper">
  <div class="credential-library-container">
    <div class="header">
      <img
        src="../../../../assets/Logos/Overtur Logo.png"
        alt="overtur orange logo"
        width="60"
        height="50"
      />
      <h1>Overtur Subscriptions</h1>
    </div>
    <br />
    <div class="overtur-table-section">
      <div class="table-header">
        <h1>All Subscriptions</h1>
        <div class="table-buttons">
          <button
            mat-flat-button
            color="primary"
            [routerLink]="['/overtur-create-trial-subscriptions']"
          >
            <mat-icon>add</mat-icon>
            Create Trial Subscription
          </button>
        </div>
      </div>
      <mat-table #table [dataSource]="dataSource" matSort class="fixed-table">
        <ng-container matColumnDef="companyName">
          <mat-header-cell
            class="header-cell date-column-header"
            *matHeaderCellDef
          >
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Company Name</mat-label>
              <input
                matInput
                placeholder="Search Company"
                [(ngModel)]="companyNameFilter"
                (ngModelChange)="applyFilters()"
              />
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="companyName-column">{{
            element.companyName || "No Company Name Provided"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="endUserEmail">
          <mat-header-cell
            class="header-cell product-column-header"
            *matHeaderCellDef
          >
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>EndUser Email</mat-label>
              <input
                matInput
                placeholder="Enter Email"
                [(ngModel)]="emailFilter"
                (ngModelChange)="applyFilters()"
              />
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="email-column">{{
            element.endUserEmail || "No Email Provided"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="subscriptionId">
          <mat-header-cell
            class="header-cell product-column-header"
            *matHeaderCellDef
          >
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Sub ID</mat-label>
              <input
                matInput
                placeholder="Search Sub ID"
                [(ngModel)]="subscriptionIdFilter"
                (ngModelChange)="applyFilters()"
              />
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="subId-column">{{
            element.subscriptionId || "No Sub ID Provided"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="sku">
          <mat-header-cell
            class="header-cell component-column"
            *matHeaderCellDef
          >
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>SKU</mat-label>
              <input
                matInput
                placeholder="Search SKU"
                [(ngModel)]="skuFilter"
                (ngModelChange)="applyFilters()"
              />
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="sku-column">
            {{ element.sku || "No SKU Provided" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="startDate">
          <mat-header-cell class="header-cell" *matHeaderCellDef>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="startPicker"
                placeholder="Search Date"
                [(ngModel)]="startDateFilter"
                (dateChange)="applyFilters()"
                (input)="onStartDateInput($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="startPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="startDate-column">{{
            element.startDate
              ? (element.startDate | date: "MM/dd/yyyy")
              : "No Start Date Provided"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="expirationDate">
          <mat-header-cell
            class="header-cell purchaser-email-header"
            *matHeaderCellDef
          >
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Expiration Date</mat-label>
              <input
                matInput
                [matDatepicker]="expirationPicker"
                placeholder="Search Date"
                [(ngModel)]="expirationDateFilter"
                (dateChange)="applyFilters()"
                (input)="onExpirationDateInput($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="expirationPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #expirationPicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="expirationDate-column"
            ><span class="email-text">{{
              element.expirationDate
                ? (element.expirationDate | date: "MM/dd/yyyy")
                : "No Expiration Date Provided"
            }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="subscriptionStatus">
          <mat-header-cell
            class="header-cell purchaser-email-header"
            *matHeaderCellDef
          >
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              class="status-filter"
            >
              <mat-label>Status</mat-label>
              <mat-select
                [(value)]="statusFilter"
                (selectionChange)="applyFilters()"
                placeholder="Select Status"
                disableRipple
              >
                <mat-option value="">All</mat-option>
                <mat-option value="Active">Active</mat-option>
                <mat-option value="Failed">Failed</mat-option>
                <mat-option value="Expired">Expired</mat-option>
                <mat-option value="AutoRevoked">AutoRevoked</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-chip
              [ngClass]="{
                'chip-active': element.subscriptionStatus === 'Active',
                'chip-failed': element.subscriptionStatus === 'Failed',
                'chip-expired': element.subscriptionStatus === 'Expired',
                'chip-autorevoked': element.subscriptionStatus === 'AutoRevoked'
              }"
            >
              {{ element.subscriptionStatus || "No Status Provided" }}
            </mat-chip>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell
            class="header-cell actions-column-header"
            *matHeaderCellDef
          ></mat-header-cell>
          <mat-cell *matCellDef="let element" class="actions-column">
            <button
              mat-icon-button
              [matMenuTriggerFor]="moreMenu"
              color="accent"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #moreMenu="matMenu">
              <button mat-menu-item (click)="editSubItem(element)">
                <mat-icon>edit</mat-icon>
                <span>View/Edit</span>
              </button>
              <button
                mat-menu-item
                (click)="deleteSubItem(element)"
                [disabled]="!element.canDelete"
              >
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu></mat-cell
          >
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</div>
